"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.replace");

var _axios = _interopRequireDefault(require("axios"));

var _themeCurrency = require("@shopify/theme-currency");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-free-shipping="container"]'
};
var strings = {
  currency: window.theme.currency,
  messages: window.theme.freeShipping.messages,
  threshold: window.theme.freeShipping.threshold
};
/**
 * Create new free shipping object.
 */

var _default = function _default() {
  function init() {
    updateValues();
    setListener();
  }
  /**
  * DOM node selectors.
  */


  var nodeSelectors = {
    container: document.querySelector(selectors.container)
  };
  /**
   * Set listeners.
   */

  function setListener() {
    Frame.EventBus.listen(['AjaxCart:quantityUpdated'], function () {
      updateValues();
    });
    Frame.EventBus.listen(['AjaxCart:cartItemRemoved'], function () {
      updateValues();
    });
  }

  function updateValues() {
    _axios["default"].get('/cart.js').then(function (response) {
      render(response.data);
      return response.data;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }

  function render(data) {
    var total = data.total_price;
    var difference = strings.threshold - total;

    if (difference <= 0) {
      nodeSelectors.container.innerHTML = strings.messages.ideal;
    }

    if (total < strings.threshold && total >= 0) {
      if (nodeSelectors.container !== null) {
        nodeSelectors.container.innerHTML = strings.messages.partial.replace('#value#', getFormattedCurrency(difference));
      }
    }
  }

  function getFormattedCurrency(cents) {
    return (0, _themeCurrency.formatMoney)(cents, theme.moneyFormat);
  }
  /**
  * Expose public interface.
  */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;